import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dcf-common-submit-button',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div>
      <button
        type="submit"
        class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
        Submit
      </button>
    </div>
  `
})
export class DcfCommonSubmitButtonComponent {
}
